<div class="pl-shell flex h-full w-full flex-col">
  <pl-header
    [disableLinkOnPlLogo]="disableLinkOnPlLogoFromRouteData() || !!error()?.hideLoggedInButtonsInHeader"
    [hideMenu]="hideMenuFromRouteData() || !!error()?.hideLoggedInButtonsInHeader"
    [hideProfileSection]="hideProfileSectionFromRouteData() || !!error()?.hideLoggedInButtonsInHeader"
    [isMenuOpen]="sidenav.opened"
  ></pl-header>

  <mat-sidenav-container class="grow">
    <mat-sidenav #sidenav [mode]="mode()" [fixedInViewport]="false" class="border-r-0">
      <pl-menu (stepMenuItemClicked)="onStepMenuItemClicked()"></pl-menu>
    </mat-sidenav>

    <mat-sidenav-content (scrollend)="onScrollEnd()">
      <div class="flex h-full w-full flex-col justify-between">
        <pl-company-banner
          *ngIf="companyBannerOptions() && !customisations().hideCompanyBanner"
          [options]="companyBannerOptions()"
        />
        <div
          class="grow flex flex-col"
          [class.overflow-hidden]="handleScrollWithinComponent() || customisations().handleScrollWithinBlock"
        >
          <pl-error-display *ngIf="!!error(); else routerOutlet" [error]="error()" />
          <ng-template #routerOutlet>
            <div
              class="grow"
              [class.overflow-hidden]="handleScrollWithinComponent() || customisations().handleScrollWithinBlock"
            >
              <router-outlet></router-outlet>
            </div>
          </ng-template>
          <pl-footer *ngIf="!customisations().hideFooter"></pl-footer>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
